import React, { useEffect } from 'react';
import { Modal, Form, Input, InputNumber, DatePicker, Button, Row, Col, Typography, message } from 'antd';
import dayjs from 'dayjs';
import { useCreatePaymentMutation } from '../../store/api/financeApi';

const { Text } = Typography;

export interface CreateApplicationClientPaymentModalProps {
  open: boolean;
  applicationId: number | null;
  applicationLabel?: string;
  onCancel: () => void;
  onSuccess?: () => void;
}

const CreateApplicationClientPaymentModal: React.FC<CreateApplicationClientPaymentModalProps> = ({
  open,
  applicationId,
  applicationLabel,
  onCancel,
  onSuccess
}) => {
  const [form] = Form.useForm();
  const [createPayment, { isLoading }] = useCreatePaymentMutation();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        amount: undefined,
        paymentDate: dayjs(),
        comment: ''
      });
    }
  }, [open, form]);

  const handleSubmit = async () => {
    if (applicationId == null || applicationId <= 0) {
      message.error('Не выбрана заявка');
      return;
    }
    const v = await form.validateFields();
    try {
      await createPayment({
        applicationId,
        amount: Number(v.amount),
        paymentDate: v.paymentDate ? dayjs(v.paymentDate).format('YYYY-MM-DD') : undefined,
        comment: v.comment ? String(v.comment).trim() : undefined
      }).unwrap();
      message.success('Платёж зарегистрирован и распределён по обязательствам');
      form.resetFields();
      onSuccess?.();
      onCancel();
    } catch (e: any) {
      message.error(e?.data?.error || 'Не удалось создать платёж');
    }
  };

  return (
    <Modal
      title="Оплата от клиента (по заявке)"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      width={480}
    >
      {applicationId != null && (
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
          Заявка: <strong>{applicationLabel || `#${applicationId}`}</strong>
        </Text>
      )}
      <Form form={form} layout="vertical">
        <Form.Item
          name="amount"
          label="Сумма платежа"
          rules={[
            { required: true, message: 'Укажите сумму' },
            { type: 'number', min: 0.01, message: 'Сумма должна быть больше 0' }
          ]}
        >
          <InputNumber min={0.01} step={1000} style={{ width: '100%' }} placeholder="Например, 30000" />
        </Form.Item>
        <Form.Item name="paymentDate" label="Дата платежа" rules={[{ required: true }]}>
          <DatePicker style={{ width: '100%' }} format="DD.MM.YYYY" />
        </Form.Item>
        <Form.Item name="comment" label="Комментарий">
          <Input.TextArea rows={2} placeholder="Предоплата, частичная оплата…" maxLength={500} />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Button block onClick={onCancel}>
              Отмена
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" block loading={isLoading} onClick={() => void handleSubmit()}>
              Записать платёж
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CreateApplicationClientPaymentModal;
